import { css } from 'lit';

export const IxSearchBarStyle = css`
  :host {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid lightgrey;
    border-width: 1px 0;
    padding: 1rem 0;
    flex-wrap: wrap;
    margin-bottom: 1.5rem;
  }

  html {
    color: #333;
  }

  ix-textbox {
    color: #333;
    flex: 1 0 min(280px, 100%);
  }

  .items-count {
    flex: 1000 0 7em;
    text-align: right;
    padding: 0.5em 0;
  }
`;
